import { AbacPermissions } from '@abac/types';

export const plannerPermissions: AbacPermissions = {
  PLANNER_SUBMODULES: 'PLANNER_SUBMODULES',
  PLANNER_NEW: 'PLANNER_NEW'
};
